// extracted by mini-css-extract-plugin
export var backdropImageSection = "index-module--backdropImageSection--3H55S";
export var bgContainer = "index-module--bgContainer--8coKh";
export var container = "index-module--container--hFBv5";
export var section = "index-module--section--cbO0+";
export var specBox = "index-module--specBox--KlBKZ";
export var specDescription = "index-module--specDescription--r5pUL";
export var specList = "index-module--specList--TKg-4";
export var specTitle = "index-module--specTitle--uJZw4";
export var title = "index-module--title--mU9LZ";